import { globToRegExp, KeyValueConfigSchema, type KeyValueConfig } from '@hud/core';
import { registerWidget, type WidgetProps } from '../registry.js';
import { useStore } from '../hooks/useStore.js';
import './keyvalue.css';

const COUNT_PREFIX = 'count:';

/**
 * Label-left, value-right stat rows.
 *
 * A value is normally a literal, but `count:books/**` counts matching vault
 * files instead — so "BOOKS 39" stays honest as you add files rather than being
 * a number you have to remember to update.
 */
function KeyValue({ config }: WidgetProps<KeyValueConfig>) {
  const store = useStore();
  const entries = store.index().entries;

  return (
    <dl class="hud-kv">
      {config.rows.map((row) => (
        <div class="hud-kv__row" key={row.label}>
          <dt class="hud-kv__label">{row.label}</dt>
          <dd class="hud-kv__value">{resolve(row.value, entries)}</dd>
        </div>
      ))}
    </dl>
  );
}

function resolve(value: string | number, entries: { path: string }[]): string {
  if (typeof value === 'number') return value.toLocaleString('en-US');
  if (!value.startsWith(COUNT_PREFIX)) return value;

  const pattern = globToRegExp(value.slice(COUNT_PREFIX.length).trim());
  return entries.filter((entry) => pattern.test(entry.path)).length.toLocaleString('en-US');
}

registerWidget({
  type: 'keyvalue',
  schema: KeyValueConfigSchema,
  component: KeyValue,
});
